import { ConfidenceInterval } from '../ui/components/questionnaire/OverallConfidenceQuestion'

export class Question {
  id: string
  name: string
  displayText: string
  displayDescription?: string

  constructor (payload: any) {
    this.id = payload.id
    this.name = payload.name as string
    this.displayText = payload.display_text as string
    this.displayDescription = payload.display_description as string
  }
}

export class Section {
  name: string
  displayText: string
  questions: Question[]
  displayDescription?: string

  constructor (payload: any) {
    this.name = payload.name as string
    this.displayText = payload.display_text as string
    this.displayDescription = payload.display_description as string
    this.questions = payload.questions.map((questionPayload: any) => {
      return new Question(questionPayload)
    })
  }
}

export interface SelectedAnswer {
  answer: number
  comment?: string
}

class Questionnaire {
  sections: Section[]
  _selectedAnswers: Map<string, SelectedAnswer>
  overallConfidence: ConfidenceInterval = 5
  overallComments: string = ''
  pitchDeckQuality: number = 0

  constructor (payload: any) {
    this.sections = payload.map((sectionPayload: any) => {
      return new Section(sectionPayload)
    })

    this._selectedAnswers = new Map()
  }

  selectAnswer = (answer: number, question: Question, comment?: string) => {
    this._selectedAnswers.set(question.id, {
      answer: answer,
      comment: comment
    })
  }

  isCompleted = () => {
    for (const section of this.sections) {
      for (const question of section.questions) {
        if (!this._selectedAnswers.has(question.id)) {
          return false
        }
      }
    }

    if (!this.pitchDeckQuality) {
      return false
    }

    if (!this.overallConfidence) {
      return false
    }
    return true
  }

  selectedAnswers = () => {
    const keys = Array.from(this._selectedAnswers.keys())
    return keys.map((key: string) => {
      const selectedAnswer = this._selectedAnswers.get(key)!
      return {
        uuid: key,
        answer: selectedAnswer.answer,
        comment: selectedAnswer.comment?.length ? selectedAnswer.comment : null
      }
    })
  }
}

export default Questionnaire
